<template>
    <div>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
<!--                <a class="nav-link" href="#" role="tab" data-toggle="tab">Medical</a>-->
                <router-link
                    :to="{ name: 'CrewMedical' }"
                    tag="a"
                    class="nav-link text-dark"
                    :class="{'active bg-light-gray': isActiveRoute('CrewMedical')}"
                    role="tab"
                    data-toggle="tab"
                >
                    Medical
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'HealthChecklist' }"
                    tag="a"
                    class="nav-link text-dark"
                    :class="{'active bg-light-gray': isActiveRoute('HealthChecklist')}"
                    role="tab"
                    data-toggle="list"
                >
                    Health Checklist
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'PcrRapidTest' }"
                    tag="a"
                    class="nav-link text-dark"
                    :class="{'active bg-light-gray': isActiveRoute('PcrRapidTest')}"
                    role="tab"
                    data-toggle="list"
                >
                    Rapid/PCR Test
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'CovidVaccineIndex' }"
                    tag="a"
                    class="nav-link text-dark"
                    :class="{'active bg-light-gray': isActiveRoute('CovidVaccineIndex')}"
                    role="tab"
                    data-toggle="list"
                >
                    Covid Vaccine
                </router-link>
            </li>
        </ul>
    </div>

</template>

<script>

import { vueAppMixin } from "@/mixins/vueAppMixin";

export default {
    name: "MedicalNavigation",
    mixins: [ vueAppMixin ]
}
</script>

<style scoped>

ul > li,
ul > li > button {
    color: white;
    margin: 0 1px;
}
ul > li > button:focus,
ul > li > button:active {
    outline:none;
}

li>button.active, .nav-tabs .nav-link.active {
    background: white !important;
    font-weight: bold;
    color: black ;
}
.bg-online-exam-red {
    background-color: #c53030;
}
.bg-light-gray {
    background-color: lightgray;
}

ul>li>a.nav-link.active {
    font-weight: bold;
    background-color: lightgray !important;
    border-color: lightgray;
    color: #c53030 !important;
}

</style>